import React from 'react'
import ExpenseListFilters from './ExpenseListFilters'
import ExpenseSummary from './ExpenseSummary'
import ExpenseList from './ExpenseList'

const ExpenseDashboardPage = () => (
  <div>
    <ExpenseSummary />
    <ExpenseListFilters />
    <ExpenseList />
  </div>
)

export default ExpenseDashboardPage


// WEBPACK FOOTER //
// ./src/components/ExpenseDashboardPage.js